import SingleAppointment from "./SingleAppointment";

const SinglePeriodAppointments = ({ period, appointments, name }) => {
  return (
    <div className="single-period">
      <div className="title font-medium text-base mb-5">
        <span>{period}</span>
      </div>
      <div className="appointment-lists">
        <ul className="flex flex-wrap">
          {appointments.map((appointment, index) => {
            return (
              <li className="px-2 pb-3 flex-auto" key={index}>
                <SingleAppointment
                  inputId={`input-${appointment.id}`}
                  name={name}
                />
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default SinglePeriodAppointments;
